import { TParallaxTranslatePattern } from './ParallaxContext';

type TUpdateTransaform = {
    perspective: number,
    translateOffset: TParallaxTranslatePattern,
    translateOffsetStart: TParallaxTranslatePattern,
    offset: number,
}

export const updateTransform = ({
    perspective,
    translateOffset: [
        speedX,
        speedY = 0,
        speedZ = 0,
    ],
    translateOffsetStart: [
        startX,
        startY = 0,
        startZ = 0,
    ],

    offset,
}: TUpdateTransaform) => {
    const translateX = startX + speedX * offset;
    const translateY = startY + speedY * offset;
    const translateZ = startZ + speedZ * offset;

    const calculatedTranslate = [
        translateX,
        translateY,
        translateZ,
    ]
        .map(value => `${value}px`)
        .join(', ');

    return `perspective(${perspective}px) translate3d(${calculatedTranslate})`;
};
